import classnames from 'classnames';
import styles from './more-item.module.less';
import moreVertIcon from '@sb1/ffe-icons/icons/open/300/md/more_vert.svg';
import { Icon } from '@sb1/ffe-icons-react';
import { Tooltip } from '../tooltip/Tooltip';

const MoreButtonItem = ({ theme, isMobileToolbarOpen, setIsMobileToolbarOpen }) => {
    const onClick = (e) => {
        e.preventDefault();
        setIsMobileToolbarOpen(!isMobileToolbarOpen);
    };

    return (
        <Tooltip text="Mer">
            <button
                className={classnames(styles.moreItem, {
                    [theme?.active]: isMobileToolbarOpen,
                    [theme?.button]: true,
                })}
                onClick={onClick}
                onMouseDown={(e) => e.preventDefault()}
            >
                <Icon fileUrl={moreVertIcon} />
            </button>
        </Tooltip>
    );
};
export default MoreButtonItem;
